import {
  OutlinedInput, InputLabel, ListItemText, Select,
} from '@mui/material';
import { translationMap, mapBackendKeyToStateKey } from '../../lib/index';
import { StyledCheckbox } from './StyledCheckbox';
import { StyledMenuItem } from './StyledMenuItem';
import { StyledSelect } from './StyledSelect';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '80vh',
      width: 250,
    },
  },
};

export default function MultiselectFocus({
  focalPoints,
  filter,
  setFilter,
  fullWidth,
}) {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setFilter({
      ...filter,
      focus: typeof value === 'string' ? value.split(',') : value,
    });
  };

  return (
    <StyledSelect fullWidth={fullWidth}>
      <InputLabel id="filter-focal-points">Schwerpunkte</InputLabel>
      <Select
        labelId="filter-focal-points"
        multiple
        value={filter.focus}
        onChange={handleChange}
        input={<OutlinedInput label="Schwerpunkte" />}
        renderValue={(selected) => selected.map((e) => mapBackendKeyToStateKey(e, translationMap)).join(', ')}
        MenuProps={MenuProps}
      >
        {focalPoints.map((point) => (
          <StyledMenuItem key={point} value={point}>
            <StyledCheckbox checked={filter.focus?.indexOf(point) > -1} />
            <ListItemText primary={
                mapBackendKeyToStateKey(point, translationMap)
              }
            />
          </StyledMenuItem>
        ))}
      </Select>
    </StyledSelect>
  );
}
